import { useMutation } from "urql";

import { DeleteLimitRequestPaymasterDocument } from "../../../../graphql/generated.ts";

export function useDeleteLimitRequestPaymaster() {
  return useMutation(DeleteLimitRequestPaymasterDocument);
}
